// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"913fb3dc","488":"c751eb84","493":"6963d41b","547":"4b5464dd","639":"b936a442","710":"16f44f3f"}[chunkId] + ".chunk.js";
};